/**
 * Контент справки для страницы технічного обслуговування.
 * Используется в панели справки HelpPanel.
 */
export default {
  // Идентификатор страницы
  pageKey: 'maintenance',

  // Ключ локализации заголовка страницы
  titleKey: 'help.pages.maintenance.title',

  // Ключ локализации описания страницы
  overviewKey: 'help.pages.maintenance.overview',

  // Идентификатор связанного тура
  tourId: 'maintenance-page',

  // FAQ - часто задаваемые вопросы
  faq: [
    {
      id: 'create-task',
      questionKey: 'help.pages.maintenance.faq.createTask.question',
      answerKey: 'help.pages.maintenance.faq.createTask.answer',
    },
    {
      id: 'task-status',
      questionKey: 'help.pages.maintenance.faq.taskStatus.question',
      answerKey: 'help.pages.maintenance.faq.taskStatus.answer',
    },
    {
      id: 'service-types',
      questionKey: 'help.pages.maintenance.faq.serviceTypes.question',
      answerKey: 'help.pages.maintenance.faq.serviceTypes.answer',
    },
    {
      id: 'complete-task',
      questionKey: 'help.pages.maintenance.faq.completeTask.question',
      answerKey: 'help.pages.maintenance.faq.completeTask.answer',
    },
    {
      id: 'import-export',
      questionKey: 'help.pages.maintenance.faq.importExport.question',
      answerKey: 'help.pages.maintenance.faq.importExport.answer',
    },
    {
      id: 'reminders',
      questionKey: 'help.pages.maintenance.faq.reminders.question',
      answerKey: 'help.pages.maintenance.faq.reminders.answer',
    },
  ],

  // Контекстные подсказки для элементов страницы
  tooltips: {
    statsCards: 'help.tooltips.maintenance.statsCards',
    taskCard: 'help.tooltips.maintenance.taskCard',
    history: 'help.tooltips.maintenance.history',
    deviceFilter: 'help.tooltips.maintenance.deviceFilter',
  },

  // Связанные туры
  relatedTours: ['onboarding', 'devices-page', 'reports-page'],
}
